import * as ambassadorWixMetroinspectorV1Long from './metroinspector-v1-long-echo.http.js';
import * as ambassadorWixMetroinspectorV1LongTypes from './metroinspector-v1-long-echo.types.js';
import * as ambassadorWixMetroinspectorV1LongUniversalTypes from './metroinspector-v1-long-echo.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function publicLongEcho(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixMetroinspectorV1LongUniversalTypes.LongMessage,
  ambassadorWixMetroinspectorV1LongTypes.LongMessage,
  ambassadorWixMetroinspectorV1LongUniversalTypes.LongMessage,
  ambassadorWixMetroinspectorV1LongTypes.LongMessage
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMetroinspectorV1Long.publicLongEcho(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/public-long',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export { LongMessage as LongMessageOriginal } from './metroinspector-v1-long-echo.types.js';
